import React from "react";
import "./discover.css";
import "./swiper.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { izProviderConfigsAtom, highContrastAtom } from "../../jotai/atoms";
import i18n from "../../i18n";

export function Discover() {
  const { t } = useTranslation();
  const [providerConfigs] = useAtom(izProviderConfigsAtom);
  const [highContrast] = useAtom(highContrastAtom);

  const getProviderSlide = (destinationId: string) => {
    if (!i18n.exists(`discover.page_${destinationId}`)) return <></>;
    return (
      <SwiperSlide key={destinationId}>
        <div className="flex flex-col gap-4">
          <div className="rounded-xl dark:bg-docket-primary w-[95%] mx-auto">
            <img src={`/assets/images/Discover_${destinationId.toUpperCase()}.png`} />
          </div>
          <p className="text-black dark:text-white mobile-text-color text-lg px-8 md:mt-4">
            {t(`discover.page_${destinationId}`)}
          </p>
        </div>
      </SwiperSlide>
    );
  };

  return (
    <>
      <div
        className="discover-container md:!hidden max-md:mt-[30px]"
        data-testid="discover-container"
      >
        <Swiper
          pagination={{
            el: ".swiper-pagination",
            clickable: true,
          }}
          modules={[Pagination]}
        >
          <SwiperSlide key="intro">
            <div className="flex flex-col gap-4">
              <div className="rounded-xl dark:bg-docket-primary w-[95%] mx-auto">
                <img className="inline dark:hidden" src="/assets/images/Discover_1_Light.png" />
                <img className="hidden dark:inline" src="/assets/images/Discover_1_HC.png" />
              </div>
              <p className="mobile-text-color text-lg px-8">{t("discover.page1")}</p>
            </div>
          </SwiperSlide>
          {providerConfigs
            .sort((a, b) => (a.iz_provider.name < b.iz_provider.name ? -1 : 1))
            .map((provider) => {
              const destinationId = provider.iz_provider.destination_id.toLowerCase();
              return getProviderSlide(destinationId);
            })}
          <SwiperSlide key="end">
            <div className="flex flex-col gap-4">
              <div className="rounded-xl dark:bg-docket-primary w-[95%] mx-auto">
                <img src={`/assets/images/Doctors_Background.png`} />
              </div>
              <p className="text-black dark:text-white mobile-text-color text-lg px-8 md:mt-4">
                {t("discover.page3")}
              </p>
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="swiper-pagination md:hidden"></div>
      </div>
      <div className="discover-container max-md:!hidden">
        <Swiper navigation={true} modules={[Navigation]}>
          <SwiperSlide key="intro">
            <img src="/assets/images/Discover_1_Light.png" />
            <p className="text-black dark:text-white text-lg px-8 mt-4">{t("discover.page1")}</p>
          </SwiperSlide>
          {providerConfigs
            .sort((a, b) => (a.iz_provider.name < b.iz_provider.name ? -1 : 1))
            .map((provider) => {
              const destinationId = provider.iz_provider.destination_id.toLowerCase();
              return getProviderSlide(destinationId);
            })}
          <SwiperSlide key="end">
            <img src="/assets/images/Doctors_Background.png" />
            <p className="text-black dark:text-white text-lg px-8 mt-4">{t("discover.page3")}</p>
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  );
}

export default Discover;
